import { globalStyle, style } from '@vanilla-extract/css';

export const bottomContainer = style({
  padding: '0px var(--wt-padding) var(--wt-padding)',
  fontSize: '.75rem',
  lineHeight: '1rem',
  textAlign: 'left',
  opacity: '.75',
});

export const listContainer = style({
  padding: '0px var(--wt-padding) var(--wt-padding)',
  textAlign: 'left',
});

export const list = style({
  padding: 0,
  margin: 0,
  marginLeft: 25,
  color:
    'var(--post-section-text-color, var(--site-theme-text-on-background-color, var(--wt-paragraph-color, inherit)))',
  listStyleType: 'var(--list-style-type)',
  textAlign: 'inherit',
});

export const listDefault = style({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  minWidth: 300,
  width: 'fit-content',
  marginLeft: 0,
});

export const listInline = style({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  marginLeft: 0,
});

globalStyle(`${list}:not(${listDefault}):not(${listInline}) > li + li`, {
  marginTop: 4,
});

globalStyle(`${list} > li`, {
  fontFamily: 'var(--wt-list-font-family)',
  fontSize: 'var(--wt-list-font-size)',
});

export const inlineLink = style({
  fontWeight: 'var(--wt-inline-link-font-weight)',
  fontStyle: 'var(--wt-inline-link-font-style)',
  textDecoration:
    'var(--wt-inline-link-underline) var(--post-section-text-color, var(--site-theme-text-on-background-color, var(--wt-inline-link-underline-color)))',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, inherit))',
});

export const question = style({
  textAlign: 'left',
  margin: 0,
  fontSize: 'var(--wt-h3-font-size)',
  fontFamily: 'var(--wt-h3-font-family)',
  fontWeight: 'var(--wt-h3-font-weight)',
  lineHeight: 'var(--wt-h3-line-height)',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, inherit))',
});

export const description = style({
  textAlign: 'left',
  fontSize: 'var(--wt-paragraph-font-size)',
  fontFamily: 'var(--wt-paragraph-font-family)',
  lineHeight: 'var(--wt-paragraph-line-height)',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, inherit))',
});

export const topContainer = style({
  padding: 'var(--wt-padding) var(--wt-padding) var(--wt-paragraph-padding-bottom)',
});
